import { render, staticRenderFns } from "./registration-recording.vue?vue&type=template&id=46e40547&"
import script from "./registration-recording.vue?vue&type=script&lang=js&"
export * from "./registration-recording.vue?vue&type=script&lang=js&"
import style0 from "./registration-recording.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registration-recording.vue"
export default component.exports